// WhatsApp Web exact colors
export const whatsappColors = {
  bg: '#f0f2f5',
  panelBg: '#ffffff',
  headerBg: '#f0f2f5',
  searchBg: '#f0f2f5',
  chatBg: '#efeae2',
  border: '#e9edef',
  borderDark: '#d1d7db',
  textPrimary: '#111b21',
  textSecondary: '#667781',
  textTertiary: '#8696a0',
  iconGray: '#54656f',
  hoverBg: '#f5f6f6',
  activeBg: '#f0f2f5',
  green: '#00a884',
  greenLight: '#d9fdd3',
  greenDark: '#0a5c2e',
  blue: '#53bdeb',
  bubbleOut: '#d9fdd3',
  bubbleIn: '#ffffff',
  unreadBadge: '#25d366',
  sendButton: '#25d366',
  sendButtonHover: '#1fb457',
} as const;

export interface ConversationItemData {
  id: string;
  contactName: string;
  contactPhone: string;
  lastMessage: string;
  lastMessageTime: string;
  isOutbound: boolean;
  isRead: boolean;
  unreadCount: number;
  isActive: boolean;
  isWindowClosed: boolean;
  windowExpiresAt?: string;
}

export interface MessageData {
  kind?: 'message' | 'separator';
  id: string;
  text: string;
  time: string;
  direction: 'inbound' | 'outbound';
  status?: 'sent' | 'delivered' | 'read' | 'failed';
  type: 'text' | 'template';
  templateId?: string;
  conversationId?: string;
}

export interface MessageGroup {
  date: string;
  isToday: boolean;
  messages: MessageData[];
}
